module.exports = __webpack_public_path__ + "img/VI.95eb989d.svg";